import { map, startCase } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styles from './Deliveries.module.css';

const makeSelectOptions = (locations) =>
  map(locations, (location) => ({
    value: location.id,
    label: startCase(location.name),
  }));

const customStyle = {
  option: (style, { isSelected, isFocused }) => ({
    ...style,
    backgroundColor: isSelected || isFocused ? 'black' : 'white',
    color: isSelected || isFocused ? 'white' : 'black',
    lineHeight: '22px',
    fontSize: '14px',
    ':active': 'black',
    letterSpacing: '1px',
  }),
};

class LocationSelector extends Component {
  constructor(props) {
    super(props);

    props.onChange(props.selectedLocation.id);
  }

  render() {
    const { locations, selectedLocation, onChange } = this.props;

    return (
      <div className={styles.locationSelectorContainer}>
        <div
          className={styles.locationSelector}
          data-testid="deliveries-location-selector"
        >
          <Select
            onChange={({ value }) => onChange(value)}
            value={{
              value: selectedLocation.id,
              label: startCase(selectedLocation.name),
            }}
            options={makeSelectOptions(locations)}
            styles={customStyle}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary: 'black',
              },
            })}
          />
        </div>
      </div>
    );
  }
}

LocationSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedLocation: PropTypes.shape({ id: PropTypes.string.isRequired })
    .isRequired,
  locations: PropTypes.shape({}).isRequired,
};

export default LocationSelector;
